package api.dataclasses.deliveries

import api.interfaces.ICSMarksAllowedFieldParser
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Suppress("ArrayInDataClass")
@Serializable
data class DeliveryDetailed(
    @SerialName("RecordId") val recordId: Int,
    @SerialName("Eigenaar") val owner: String?,
    @SerialName("Opdrachtnummer") val orderNumber: String,
    @SerialName("Weeknummer") val weekNumber: Int,
    @SerialName("Behandeling") val treatment: String,
    @SerialName("Omschrijving") val description: String,
    @SerialName("Emailadres") val email: String,
    @SerialName("Ontvangen_Detail") val receivedDetail: String,
    @SerialName("Ontvanger") val receiver: String,
    @SerialName("Referentie") val reference: String,
    @SerialName("Statusomschrijving") val statusDescription: String,
    @SerialName("Tijdstatus") val timeStatus: String,
    @SerialName("Totaal_verwacht") val totalExpected: String,
    @SerialName("Totaal_ontvangen") val totalReceived: String,
    @SerialName("Verwacht_Detail") val expectedDetail: String,
    @SerialName("Verwachte_datum") val expectedDate: String,
    @SerialName("Verwerkingsdatum") val processingDate: String,
    @SerialName("Fields") override val fields: Array<String>
) : ICSMarksAllowedFieldParser
